"use client"

import { FolderX } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FolderXIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FolderXIcon = component(Icon)({ as: FolderX })
